import type { Application } from '#/domain/application/Application'
import type { ApplicationRepository } from '#/domain/application/ApplicationRepository'

export class GetApplicationListUseCase {
  constructor(private readonly repository: ApplicationRepository) {}

  async execute(): Promise<Application[]> {
    return this.repository.findAll()
  }
}
